import { render } from "./SubBanner.vue?vue&type=template&id=4926cfab"
import script from "./SubBanner.vue?vue&type=script&lang=js"
export * from "./SubBanner.vue?vue&type=script&lang=js"

import "./SubBanner.vue?vue&type=style&index=0&id=4926cfab&lang=scss"

import exportComponent from "/Users/Sacha/Projects/ftminstallatietechniek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__